import React from "react";
import { AuthProvider } from "./AuthContext";
import { UserProvider } from "./UserContext";
import { PermissionProvider } from "./PermissionContext";
import { RoleProvider } from "./RoleContext";
import { FilterProvider } from "./FilterContext";
const SuperProvider = (props) => {
  return (
    <FilterProvider>
      <AuthProvider>
        <PermissionProvider>
          <RoleProvider>
            <UserProvider>{props.children}</UserProvider>
          </RoleProvider>
        </PermissionProvider>
      </AuthProvider>
    </FilterProvider>
  );
};
export default SuperProvider;
